import classes from './WidgetUrl.module.css';

const WidgetEmail = ({ value, onChange, disabled = false }) => {
  return (
    <input
      type="url"
      className={classes.input}
      value={value}
      onChange={(e) => {
        onChange(e.target.value);
      }}
      disabled={disabled}
    />
  );
};

export default WidgetEmail;
